import React, { useContext, useEffect, useState } from "react";
import { FormGroup } from "../../components/FormGroup";
import { ListItem } from "../../components/ListItem";
import { HexpertContext } from "../../contexts/HexPertProvider";
import { IndustryType, PageQuestion } from "../../types/hexpertTypes";
import './WeFitListItemsBlock.scss';

type WeFitListChoiceBlockProps = PageQuestion & {
  action?: () => void;
};

export const WeFitListItemsBlock = ({
  Label,
  List,
  Options,
  action,
  FieldId,
}: WeFitListChoiceBlockProps) => {
  const [items, setItems] = useState<IndustryType[]>(null);
  const { dispatch, state } = useContext(HexpertContext);

  useEffect(() => {
    const mappedItems = List?.map((list) => {
      const listOption = Options?.find(
        (option) => option?.Caption?.trim() === list?.Title?.trim()
      );
      return {
        ...list,
        ...listOption,
      };
    });
    const hasAnswer = mappedItems.find(
      (item) => item.Value === state?.formAnswers?.[FieldId]
    );
    if (hasAnswer) {
      dispatch({ type: "setIndustry", payload: hasAnswer });
    }
    setItems(mappedItems);
  }, [List]);

  useEffect(() => {
    if (
      state?.chosenIndustry &&
      !state?.formAnswers?.[FieldId] &&
      state?.showLastQuestions
    ) {
      // if we have default industry

      dispatch({
        type: "setAnswer",
        payload: { [FieldId]: state?.chosenIndustry?.Value?.toString() },
      });
    }
  }, [state?.showLastQuestions, state?.formAnswers?.[FieldId]]);

  return (
    <FormGroup title={Label}>
      <div className="c-hex-list-choice-container">
        {items?.map((item) => (
          <ListItem
            title={item.Title}
            key={item.Value}
            text={item.Description}
            active={item.Value === state?.formAnswers?.[FieldId]}
            action={() => {
              dispatch({ type: "setIndustry", payload: item });
              dispatch({
                type: "setAnswer",
                payload: { [FieldId]: item.Value?.toString() },
              });
              action();
            }}
          />
        ))}
      </div>
    </FormGroup>
  );
};
